import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'
import { allProfiles } from 'app/mocks/data/users/profiles'

import { api } from 'app/utils/constants'

import type { KonsoleUser } from 'app/types/users/konsole'
import { KonsoleUserCreatePayload } from 'app/types/users/konsole'

export const createUserKonsole = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.konsole.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = KonsoleUserCreatePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<KonsoleUser>(
            {
                id: 999,
                ...payloadParsed.data,
                groups: allProfiles.filter((profile) =>
                    payloadParsed.data.groups.includes(profile.id),
                ),
                profil: {
                    client: allManagers.filter((manager) =>
                        payloadParsed.data.profil.client.includes(manager.id),
                    ),
                },
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
